export default __webpack_public_path__ + "static/media/delivery.d2935f54.png";